<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed } from 'vue';

const props = defineProps({
    /** A model to automatically determine if this loading spinner should be shown or not. */
    size: {
        type: String as PropType<'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge' | 'xxxlarge'>,
        default: 'xxlarge'
    },
    /** Adds a custom loading message to the spinner. */
    loadingMessage: {
        type: String,
        default: ''
    },
    variant: {
        type: String as PropType<'primary' | 'secondary' | 'light' | 'dark'>,
        default: 'primary'
    }
});

const sizeClass = computed(() => {
    switch (props.size) {
        case 'xxxlarge':
            return 40;
        case 'xxlarge':
            return 32;
        case 'xlarge':
            return 24;
        case 'large':
            return 20;
        case 'medium':
            return 16;
        case 'small':
            return 14;
        default:
            return 40;
    }
});

</script>

<template>
    <SStack
        align-items="center"
        justify-content="center"
        gap="3"
    >
        <SSpinner :variant="props.variant" :size="sizeClass" />
        <SText v-if="props.loadingMessage !== ''">{{ loadingMessage }}</SText>
    </SStack>
</template>
